import { OrganisationTypes } from '@percent/domain/verifications'

const NONPROFIT_AND_EDUCATION_PAIR = [OrganisationTypes.Nonprofit, OrganisationTypes.Education] as const

export const isNonprofitAndEducationOnlyConfig = (allowedTypes: OrganisationTypes[]): boolean => {
  const allowed = new Set(allowedTypes)

  return (
    allowed.size === NONPROFIT_AND_EDUCATION_PAIR.length &&
    NONPROFIT_AND_EDUCATION_PAIR.every(type => allowed.has(type))
  )
}
